module.exports = __webpack_public_path__ + "img/Spin-1s-200px.849c03cd.svg";